/**
*  Copyright (c) 2018 Micro Focus Software Inc.  All Rights Reserved.
*
* THIS WORK IS AN UNPUBLISHED WORK AND CONTAINS CONFIDENTIAL PROPRIETARY
* AND TRADE SECRET INFORMATION OF MICRO FOCUS SOFTWARE INC. ACCESS  TO  THIS
* WORK IS RESTRICTED TO (I) MICRO FOCUS SOFTWARE INC. EMPLOYEES WHO HAVE A NEED
* TO  KNOW HOW TO  PERFORM  TASKS WITHIN  THE SCOPE  OF  THEIR   ASSIGNMENTS
* AND (II) ENTITIES OTHER  THAN  MICRO FOCUS SOFTWARE INC.  WHO  HAVE ENTERED
* INTO APPROPRIATE LICENSE   AGREEMENTS.  NO  PART  OF  THIS WORK MAY BE USED,
* PRACTICED, PERFORMED COPIED, DISTRIBUTED, REVISED, MODIFIED, TRANSLATED, ABRIDGED,
* CONDENSED, EXPANDED, COLLECTED, COMPILED, LINKED,  RECAST, TRANSFORMED
* OR ADAPTED  WITHOUT THE PRIOR WRITTEN CONSENT OF MICRO FOCUS SOFTWARE INC.
* ANY USE OR EXPLOITATION  OF  THIS WORK WITHOUT AUTHORIZATION COULD SUBJECT
* THE PERPETRATOR  TO CRIMINAL AND CIVIL LIABILITY.
*/



import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestResponse, IncidentFileUpload } from '../model/reportincident.response';
import { CustomField } from '../../../shared/model/customfieldsresponse';
import { CommonConstants } from '../../../../../common/constants/common-constants';
import { CreatedRequestResponse } from '../model/createdrequestresponse';
import { FileUploadStatus } from '../../../store/model/fileuploadstatus';


@Injectable()
export class ReportIncidentService {
    constructor(public http: HttpClient) {
    }

    // service to get custom fields
    public getCustomFields(itemTypeId , customCategory) {
        if (itemTypeId != null) {
            return this.http.get<CustomField[]>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/customfields'
            + '?itemTypeId=' + itemTypeId + '&customCategory=' + customCategory);
        } else {
            return this.http.get<CustomField[]>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests/customfields'
            + '?customCategory=' + customCategory);
            }

    }

    // Post service to create incident
    public createRequest( requestResponse: RequestResponse) {
        return this.http
            .post<CreatedRequestResponse>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/customer/requests', requestResponse);
    }

    // service for uploading attachments
    public uploadAttachments(incidentFileUpload: IncidentFileUpload) {
        const formData: FormData = new FormData();
          for (let i = 0; i < incidentFileUpload.files.length; i++) {
           formData.append('uploadFile', incidentFileUpload.files[i], incidentFileUpload.files[i].name);
           }
            return this.http.post<FileUploadStatus>(CommonConstants.SERVICE_VERSION_PATH_V1 + '/file/upload/' + incidentFileUpload.requestId
             , formData);
    }

     // service for uploading attachments in group
     public uploadAttachmentsinGroup(incidentFileUpload: IncidentFileUpload) {
        const formData: FormData = new FormData();
          for (let i = 0; i < incidentFileUpload.files.length; i++) {
           formData.append('uploadFile', incidentFileUpload.files[i], incidentFileUpload.files[i].name);
           }
            return this.http.post<string>(CommonConstants.SERVICE_VERSION_PATH_V1 +
                 '/file/upload/groupRequest/' + incidentFileUpload.requestId
             , formData);
    }
}

